import { render, staticRenderFns } from "./CardsTotalesKpiSlaPorClientes.vue?vue&type=template&id=8c29bddc&scoped=true&"
import script from "./CardsTotalesKpiSlaPorClientes.vue?vue&type=script&lang=js&"
export * from "./CardsTotalesKpiSlaPorClientes.vue?vue&type=script&lang=js&"
import style0 from "./CardsTotalesKpiSlaPorClientes.vue?vue&type=style&index=0&id=8c29bddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c29bddc",
  null
  
)

export default component.exports